<div class="chat-boundary" #chatBoundary>
  <div class="chat-window" [cdkDragBoundary]="chatBoundary" cdkDrag [class.minimized]="isMinimized" [class.confirm-open]="showCloseConfirm" [cdkDragDisabled]="showCloseConfirm">

    <div class="chat-header" cdkDragHandle>
      <div>
        <img src="../../../assets/feature-images/iris-logo.png"  alt="chat-bot" class="robot"  >
        <span class="title">Ask Iris</span>
        <img width="25px" src="../../../assets/images/beta-version.png" >
      </div>

      <div class="header-actions">
  
        <button mat-icon-button (click)="toggleMinimize()" [matTooltip]="isMinimized ? 'Expand' : 'Minimize'">
          <mat-icon>
            {{ isMinimized ? 'open_in_full' : 'remove' }}
          </mat-icon>
        </button>
        <button *ngIf="!isMinimized" mat-icon-button (click)="clearChat()" matTooltip="Clear chat">
          <mat-icon>history</mat-icon>
        </button>
        <button mat-icon-button (click)="onCloseClick()" matTooltip="Close chat">
          <mat-icon>close_outline</mat-icon>
        </button>
      </div>

      <!-- Close confirmation popover (inside chat-header for correct positioning) -->
      <div class="close-confirm-popover" *ngIf="showCloseConfirm">

        <!-- Success state -->
        <div *ngIf="mailSentToUser" class="close-confirm-success">
          <mat-icon>check_circle</mat-icon>
          <span>Chat history sent to your email!</span>
        </div>

        <!-- Default state -->
        <ng-container *ngIf="!mailSentToUser">
          <p class="close-confirm-text">Would you like the chat history emailed to you?</p>
          <div class="close-confirm-actions">
            <button mat-stroked-button class="close-confirm-no" (click)="closeWithoutEmail()" [disabled]="sendingMailToUser">
              No, thanks
            </button>
            <button mat-flat-button class="close-confirm-yes" (click)="sendMailToUserAndClose()" [disabled]="sendingMailToUser">
              <mat-icon *ngIf="!sendingMailToUser">mail_outline</mat-icon>
              {{ sendingMailToUser ? 'Sending...' : 'Yes, please' }}
            </button>
          </div>
        </ng-container>

      </div>
    </div>

    <!-- Backdrop outside cdkDragHandle — prevents backdrop from being treated as a drag surface -->
    <div class="close-confirm-backdrop" *ngIf="showCloseConfirm" (click)="showCloseConfirm = false"></div>


    <ng-container *ngIf="!isMinimized">

      <!-- Welcome empty state -->
      <div class="iris-welcome" *ngIf="!messages.length">
        
        
        <div class="iris-logo-container">
          <!-- Radar pulse rings -->
          <div class="iris-radar-pulse"></div>
          <div class="iris-radar-pulse"></div>

          <!-- Orbiting satellite -->
          <div class="iris-orbit-ring">
            <div class="iris-orbit-dot"></div>
          </div>
          <!-- Logo -->
          <div class="assistant-avatar iris-welcome-logo-wrapper">
            <img src="../../../assets/feature-images/iris-logo-animation.gif" alt="Iris" class="iris-welcome-logo" />
            
          </div>
        </div>
        
        <div class="iris-bot-greeting">
          <div class="iris-bot-speech-bubble">
            Hi! <span class="iris-wave">👋</span> I'm Iris, How can I help you today?
          </div>
        </div>
        <div class="iris-welcome-desc">
          
          <span>• Sensors information</span><br />
          <span>• Creating and managing tasks</span><br />
          <span>• Orders, budgets, and payments</span>

        </div>
        
        <div class="iris-quick-actions">
          <button mat-stroked-button class="iris-quick-btn" (click)="sendMessageToChatbot('View available sensors', 'View sensor details')">View Sensor Details</button>
          <button mat-stroked-button class="iris-quick-btn" (click)="sendMessageToChatbot('Create a new budget', 'Create a new budget')">Create a New Budget</button>
          <button mat-stroked-button class="iris-quick-btn" (click)="sendMessageToChatbot('Create a new task', 'Create a new task')">Create a New Task</button>
          <button mat-stroked-button class="iris-quick-btn" (click)="sendMessageToChatbot('View my tasks', 'View my tasks')"> View Your Tasks</button>
          <button mat-stroked-button class="iris-quick-btn" (click)="sendMessageToChatbot('Make a payment', 'Make a payment')">Make a Payment</button>
          <button mat-stroked-button class="iris-quick-btn" (click)="sendMessageToChatbot('Check my orders', 'Check my orders')">Check Your Orders</button>
          
        </div>
      </div>

      <div class="messages" *ngIf="messages.length"  id="messagesContainer" >
        <div
          class="message"
          *ngFor="let msg of messages; let i = index;let isLast = last; trackBy: trackByMessage"
          [ngClass]="msg.sender"
        >
          <div class="avatar">
            <div class="assistant-avatar" *ngIf="msg.sender === 'assistant'" [style.visibility]="msg.sender === 'assistant' && msg.disableUserInput ? 'hidden' : 'visible'">
              <img src="../../../assets/feature-images/iris-logo.png" />
            </div>
            <img [class]="this.userImg ? 'user-pr': ''" *ngIf="msg.sender === 'user'" [src]="this.userImg ? this.userImg : '../../../../assets/images/user-light.svg'"/>
          </div>

          <div class="bubble">
            <div class="bubble-content">
              <ng-container *ngIf="!msg.uiType; else structuredUi">
                <div class="preserve-newlines" [innerHtml]="msg.messageHtml ? msg.messageHtml : msg.message"></div>
              </ng-container>

              <ng-template #structuredUi>
                <ng-container *ngIf="msg.uiType === 'date_range' && msg.intent === 'orders'; else defaultStructuredUi">
                  <div class="assistant-text preserve-newlines" [innerHtml]="msg.messageHtml ? msg.messageHtml : msg.message"></div>

                  <div class="schedule-card">
                    <div class="card-row">
                      <div class="field full">
                        <label class="native-label">Start Date</label>
                        <input
                          #fpInput
                          type="text"
                          data-fp-type="date"
                          data-field="range-start"
                          [attr.data-message-index]="i"
                          [value]="formatDateForDisplayShort(msg.uiState?.dateRangeStart)"
                          [disabled]="loading || msg.uiState?.isFormSubmitted || isMessageDisabled(msg, isLast)"
                        />
                      </div>

                      <div class="field full">
                        <label class="native-label">End Date</label>
                        <input
                          #fpInput
                          type="text"
                          data-fp-type="date"
                          data-field="range-end"
                          [attr.data-message-index]="i"
                          [value]="formatDateForDisplayShort(msg.uiState?.dateRangeEnd)"
                          [disabled]="loading || msg.uiState?.isFormSubmitted || isMessageDisabled(msg, isLast)"
                        />
                      </div>
                    </div>

                    <div class="form-error" *ngIf="msg.uiState?.submitError">{{ msg.uiState.submitError }}</div>

                    <div class="card-actions">
                      <button type="button" class="send-btn predefined-submit-btn" mat-flat-button [disabled]="loading || msg.uiState?.isFormSubmitted || !msg.uiState?.isFormValid || isMessageDisabled(msg, isLast)" (click)="submitDateRange(i)">Submit</button>
                    </div>
                  </div>

                </ng-container>
                <ng-template #defaultStructuredUi>
                <ng-container [ngSwitch]="msg.uiType">
                  <div *ngSwitchCase="'options'" class="ui-options">
                    <ng-container *ngIf="msg.intentType !== 'EULA_PAYMENT'">
                      <div class="assistant-text preserve-newlines" [innerHtml]="msg.messageHtml ? msg.messageHtml : msg.message"></div>

                      <ng-container *ngIf="msg.ui?.multi_select; else singleOptions">
                        <div class="option-row" *ngFor="let opt of msg.ui?.data">
                          <label>
                            <input
                              type="checkbox"
                              [value]="opt.value"
                              [disabled]="loading || msg.uiState?.isFormSubmitted || isMessageDisabled(msg, isLast)"
                              (change)="onOptionMultiToggle(i, opt.label, opt.value, $any($event.target).checked)"
                            />
                            {{ formatOptionLabel(opt.label) }}
                          </label>
                        </div>
                        <button type="button" class="predefined-submit-btn" mat-flat-button [disabled]="loading || msg.uiState?.isFormSubmitted || isMessageDisabled(msg, isLast)" (click)="submitMultiOptions(i)">Submit</button>
                      </ng-container>

                      <ng-template #singleOptions>
                        <div class="option-row" *ngFor="let opt of msg.ui?.data">
                          <button
                            type="button"
                            class="predefined-btn"
                            mat-stroked-button
                            [disabled]="isMessageDisabled(msg, isLast) || isSpecificDayDisabled(opt.value)"
                            (click)="onOptionSelectByLabelValue(opt.label, opt.value, i)"
                          >
                            {{ formatOptionLabel(opt.label) }}

                            <mat-icon *ngIf="isSpecificDayDisabled(opt.value)" class="info-btn-icon" 
                              matTooltip="The specific day tasking is used for the current week. If a day or days of a week are required, recurrent day(s) can be used."
                              matTooltipPosition="above"
                              (click)="$event.stopPropagation()"
                            >
                              info
                            </mat-icon>
                          </button>
                        </div>
                      </ng-template>
                    </ng-container>

                    <ng-container *ngIf="msg.intentType === 'EULA_PAYMENT'">
                      <div class="assistant-text preserve-newlines" [innerHtml]="msg.messageHtml ? msg.messageHtml : msg.message"></div>

                      <div class="option-row" *ngFor="let item of pendingEulaMessages[i]?.items; let j = index">
                        <label>
                          <input
                            type="checkbox"
                            [checked]="item.enabled"
                            [disabled]="loading || msg.uiState?.isFormSubmitted || isMessageDisabled(msg, isLast)"
                            (change)="onEulaCheckboxClick($event, i, j)"
                          />
                          {{ formatOptionLabel(item.label) }}
                        </label>
                      </div>

                      <button type="button" class="predefined-submit-btn" mat-flat-button
                        [disabled]="loading || msg.uiState?.isFormSubmitted || isMessageDisabled(msg, isLast)"
                        (click)="submitEulaFromChat(i)">
                        Submit
                      </button>
                    </ng-container>
                  </div>

                  <div *ngSwitchCase="'clarify'" class="ui-clarify">
                    <div class="assistant-text preserve-newlines" [innerHtml]="msg.messageHtml ? msg.messageHtml : msg.message"></div>

                    <div class="clarify-options" [class.two-options]="(msg.ui?.data?.length === 2)">
                      <button
                        *ngFor="let opt of msg.ui?.data"
                        type="button"
                        class="clarify-btn"
                        mat-stroked-button
                        [disabled]="loading || msg.uiState?.isFormSubmitted || isMessageDisabled(msg, isLast)"
                        (click)="onOptionSelectByLabelValue(opt.label, opt.value, i)"
                      >
                        {{ formatOptionLabel(opt.label) }}
                      </button>
                    </div>
                  </div>

                  <div *ngSwitchCase="'table'" class="ui-table">

                    <div
                      class="assistant-text preserve-newlines"
                      [innerHtml]="msg.messageHtml ? msg.messageHtml : msg.message"
                    ></div>

                    <!-- TABLE SCROLL WRAPPER -->
                    <div class="table-scroll">

                      <table *ngIf="msg.ui?.data?.length > 0">

                        <thead>
                          <tr>

                            <th *ngIf="msg.ui?.multi_select"></th>

                            <th *ngFor="let col of msg.ui?.columns; trackBy: trackByColumn">
                              {{ col.header }}
                            </th>

                          </tr>
                        </thead>

                        <tbody>

                          <tr *ngFor="let row of msg.ui?.data; trackBy: trackByRow">

                            <td *ngIf="msg.ui?.multi_select">

                              <input type="checkbox"
                                [disabled]="loading || isMessageDisabled(msg, isLast)"
                                (change)=" onTableMultiToggle( i, row, $any($event.target).checked ) "
                              />

                            </td>

                            <td *ngFor="let col of msg.ui?.columns; trackBy: trackByColumn">
                                <span [innerHTML]="parseMarkdownCell(row[col.key])"></span>
                            </td>

                          </tr>

                        </tbody>

                      </table>

                    </div>

                    <div class="card-actions" *ngIf="msg.ui?.multi_select" >

                      <button type="button" class="send-btn predefined-submit-btn" mat-flat-button
                        [disabled]="isMessageDisabled(msg, isLast) || loading || msg.uiState?.isFormSubmitted || !msg.uiState?.isFormValid"
                        (click)="submitTableMultiSelect(i)"
                      >
                        Submit
                      </button>

                    </div>

                  </div>

                  <div *ngSwitchCase="'date_range'" class="ui-date-range">
                    <div class="assistant-text preserve-newlines" [innerHtml]="msg.messageHtml ? msg.messageHtml : msg.message"></div>

                    <div class="schedule-card">
                      <div class="card-row">
                        <div class="field full">
                          <label class="native-label">Start Date</label>
                              <input
                                #fpInput
                                type="text"
                                data-fp-type="date"
                                data-field="range-start"
                                [attr.data-message-index]="i"
                                [value]="formatDateForDisplayShort(msg.uiState?.dateRangeStart)"
                                [disabled]="loading || msg.uiState?.isFormSubmitted || isMessageDisabled(msg, isLast)"
                              />
                        </div>

                        <div class="field full">
                          <label class="native-label">End Date</label>
                              <input
                                #fpInput
                                type="text"
                                data-fp-type="date"
                                data-field="range-end"
                                [attr.data-message-index]="i"
                                [value]="formatDateForDisplayShort(msg.uiState?.dateRangeEnd)"
                                [disabled]="loading || msg.uiState?.isFormSubmitted || isMessageDisabled(msg, isLast)"
                              />
                        </div>
                      </div>

                      <div class="form-error" *ngIf="msg.uiState?.submitError">{{ msg.uiState.submitError }}</div>

                      <div class="card-actions">
                        <button type="button" class="send-btn predefined-submit-btn" mat-flat-button [disabled]="isMessageDisabled(msg, isLast) || loading || msg.uiState?.isFormSubmitted || !msg.uiState?.isFormValid" (click)="submitDateRange(i)">Submit</button>
                      </div>
                    </div>
                  </div>

                  <div *ngSwitchCase="'schedule'" class="ui-schedule">
                    <div class="assistant-text preserve-newlines" [innerHtml]="msg.messageHtml ? msg.messageHtml : msg.message"></div>

                    <ng-container [ngSwitch]="msg.ui?.mode || msg.ui?.data?.mode">
                      <div *ngSwitchCase="'specific_date'">
                        <div class="schedule-card">

                          <div class="card-row single">
                            <div class="field full">
                              <label class="native-label">Start Date</label>
                              <input
                                #fpInput
                                type="text"
                                data-fp-type="date"
                                data-field="specific"
                                [attr.data-message-index]="i"
                                [value]="formatDateForDisplayShort(msg.uiState?.scheduleDate)"
                                [disabled]="loading || msg.uiState?.isFormSubmitted || isMessageDisabled(msg, isLast)"
                              />
                            </div>
                          </div>

                          <div class="card-row">
                            <div class="field time-field">
                              <label class="native-label">Start Time</label>
                              <input
                                #fpInput
                                type="text"
                                data-fp-type="time"
                                data-field="start"
                                [attr.data-message-index]="i"
                                [value]="formatTimeForPayload(msg.uiState?.scheduleStartSelection || '')"
                                [disabled]="loading || msg.uiState?.isFormSubmitted || isMessageDisabled(msg, isLast)"
                              />
                              <div class="time-preview">
                                <div><strong>Selected Time:</strong> {{ msg.uiState?.scheduleStartSelection || '-' }}</div>
                                <div><strong>UTC Time:</strong> {{ msg.uiState?.scheduleStartTime || '-' }}</div>
                              </div>
                            </div>

                            <div class="field time-field">
                              <label class="native-label">End Time</label>
                              <input
                                #fpInput
                                type="text"
                                data-fp-type="time"
                                data-field="end"
                                [attr.data-message-index]="i"
                                [value]="formatTimeForPayload(msg.uiState?.scheduleEndSelection || '')"
                                [disabled]="loading || msg.uiState?.isFormSubmitted || isMessageDisabled(msg, isLast)"
                              />
                              <div class="time-preview">
                                <div><strong>Selected Time:</strong> {{ msg.uiState?.scheduleEndSelection || '-' }}</div>
                                <div><strong>UTC Time:</strong> {{ msg.uiState?.scheduleEndTime || '-' }}</div>
                              </div>
                            </div>
                          </div>

                          <div class="form-error" *ngIf="msg.uiState?.submitError">{{ msg.uiState.submitError }}</div>

                            <div class="card-actions">
                              <button type="button" class="send-btn predefined-submit-btn" mat-flat-button [disabled]="loading || msg.uiState?.isFormSubmitted || !msg.uiState?.isFormValid || isMessageDisabled(msg, isLast)" (click)="submitSpecificDateSchedule(i)">Submit</button>
                            </div>
                        </div>
                      </div>

                      <div *ngSwitchCase="'recurrent'">
                        <div class="schedule-card">
                          <div class="card-row">
                            <div class="field half">
                              <label class="native-label">Start Date</label>
                              <input
                                #fpInput
                                type="text"
                                data-fp-type="date"
                                data-field="recurrent-start"
                                [attr.data-message-index]="i"
                                [value]="formatDateForDisplayShort(msg.uiState?.recurrentStartDate)"
                                [disabled]="loading || msg.uiState?.isFormSubmitted || isMessageDisabled(msg, isLast)"
                              />
                            </div>

                            <div class="field half">
                              <label class="native-label">End Date</label>
                              <input
                                #fpInput
                                type="text"
                                data-fp-type="date"
                                data-field="recurrent-end"
                                [attr.data-message-index]="i"
                                [value]="formatDateForDisplayShort(msg.uiState?.recurrentEndDate)"
                                [disabled]="loading || msg.uiState?.isFormSubmitted || isMessageDisabled(msg, isLast)"
                              />
                            </div>
                          </div>

                          <div class="card-row">
                            <div class="field time-field">
                              <label class="native-label">Start Time</label>
                              <input #fpInput type="text" data-fp-type="time" data-field="start" [attr.data-message-index]="i" [disabled]="loading || msg.uiState?.isFormSubmitted || isMessageDisabled(msg, isLast)" />
                              <div class="time-preview">
                                <div><strong>Selected Time:</strong> {{ msg.uiState?.scheduleStartSelection || '-' }}</div>
                                <div><strong>UTC Time:</strong> {{ msg.uiState?.scheduleStartTime || '-' }}</div>
                              </div>
                            </div>

                            <div class="field time-field">
                              <label class="native-label">End Time</label>
                              <input #fpInput type="text" data-fp-type="time" data-field="end" [attr.data-message-index]="i" [disabled]="loading || msg.uiState?.isFormSubmitted || isMessageDisabled(msg, isLast)" />
                              <div class="time-preview">
                                <div><strong>Selected Time:</strong> {{ msg.uiState?.scheduleEndSelection || '-' }}</div>
                                <div><strong>UTC Time:</strong> {{ msg.uiState?.scheduleEndTime || '-' }}</div>
                              </div>
                            </div>
                          </div>

                          <div class="group frequency-group">
                            <label class="frequency-label">Repeat</label>
                            <mat-radio-group [(ngModel)]="msg.uiState.recRepeatFrequency" class="frequency-radio-group" [disabled]="loading || msg.uiState?.isFormSubmitted || isMessageDisabled(msg, isLast)">
                              <mat-radio-button value="daily">Daily</mat-radio-button>
                              <mat-radio-button value="weekly">Weekly</mat-radio-button>
                              <mat-radio-button value="monthly">Monthly</mat-radio-button>
                              <mat-radio-button value="subdaily">Subdaily</mat-radio-button>
                            </mat-radio-group>
                          </div>

                          <div class="group" *ngIf="msg.uiState?.recRepeatFrequency === 'subdaily'">
                            <mat-form-field appearance="outline">
                              <mat-label>Subdaily Count</mat-label>
                              <input matInput type="number" min="1" max="8" [(ngModel)]="msg.uiState.recSubdailyCount" (ngModelChange)="onSubdailyCountChange(i)" [disabled]="loading || msg.uiState?.isFormSubmitted || isMessageDisabled(msg, isLast)" />
                            </mat-form-field>
                          </div>

                          <div class="form-error" *ngIf="msg.uiState?.submitError">{{ msg.uiState.submitError }}</div>

                          <div class="card-actions">
                            <button type="button" class="send-btn predefined-submit-btn" mat-flat-button [disabled]="loading || msg.uiState?.isFormSubmitted || !msg.uiState?.isFormValid || isMessageDisabled(msg, isLast)" (click)="submitRecurrentSchedule(i)">Submit</button>
                          </div>
                        </div>
                      </div>

                      <div *ngSwitchCase="'period'">
                        <div class="schedule-card">
                          <div class="card-row">
                            <div class="field half">
                              <label class="native-label">Start Date</label>
                              <input
                                #fpInput
                                type="text"
                                data-fp-type="date"
                                data-field="period-start"
                                [attr.data-message-index]="i"
                                [value]="formatDateForDisplayShort(msg.uiState?.periodStartDate)"
                                [disabled]="loading || msg.uiState?.isFormSubmitted || isMessageDisabled(msg, isLast)"
                              />
                            </div>

                            <div class="field half">
                              <label class="native-label">End Date</label>
                              <input
                                #fpInput
                                type="text"
                                data-fp-type="date"
                                data-field="period-end"
                                [attr.data-message-index]="i"
                                [value]="formatDateForDisplayShort(msg.uiState?.periodEndDate)"
                                [disabled]="loading || msg.uiState?.isFormSubmitted || isMessageDisabled(msg, isLast)"
                              />
                            </div>
                          </div>

                          <div class="card-row">
                            <div class="field time-field">
                              <label class="native-label">Start Time</label>
                              <input #fpInput type="text" data-fp-type="time" data-field="start" [attr.data-message-index]="i" [disabled]="loading || msg.uiState?.isFormSubmitted || isMessageDisabled(msg, isLast)" />
                              <div class="time-preview">
                                <div><strong>Selected Time:</strong> {{ msg.uiState?.scheduleStartSelection || '-' }}</div>
                                <div><strong>UTC Time:</strong> {{ msg.uiState?.scheduleStartTime || '-' }}</div>
                              </div>
                            </div>

                            <div class="field time-field">
                              <label class="native-label">End Time</label>
                              <input #fpInput type="text" data-fp-type="time" data-field="end" [attr.data-message-index]="i" [disabled]="loading || msg.uiState?.isFormSubmitted || isMessageDisabled(msg, isLast)" />
                              <div class="time-preview">
                                <div><strong>Selected Time:</strong> {{ msg.uiState?.scheduleEndSelection || '-' }}</div>
                                <div><strong>UTC Time:</strong> {{ msg.uiState?.scheduleEndTime || '-' }}</div>
                              </div>
                            </div>
                          </div>

                          <div class="form-error" *ngIf="msg.uiState?.submitError">{{ msg.uiState.submitError }}</div>

                          <div class="card-actions">
                            <button type="button" class="send-btn predefined-submit-btn" mat-flat-button [disabled]="loading || msg.uiState?.isFormSubmitted || !msg.uiState?.isFormValid || isMessageDisabled(msg, isLast)" (click)="submitPeriodSchedule(i)">Submit</button>
                          </div>
                        </div>
                      </div>

                      <div *ngSwitchCase="'specific_day'">

                          <div class="schedule-card">

                            <div class="group frequency-group">

                              <label class="frequency-label">
                                Select Day
                              </label>

                              <mat-radio-group
                                [ngModel]="msg.uiState?.specificDay"
                                (ngModelChange)="onSpecificDaySelect($event, i)"
                                class="frequency-radio-group"
                                [disabled]="loading || msg.uiState?.isFormSubmitted || isMessageDisabled(msg, isLast)"
                              >

                                <mat-radio-button
                                  *ngFor="let day of weekDays"
                                  [disabled]="isDayDisabled(day.value, i)"
                                  [value]="day.label "
                                >
                                  {{ day.label }}
                                </mat-radio-button>

                              </mat-radio-group>

                            </div>

                            <div class="card-row">

                              <div class="field time-field">

                                <label class="native-label">
                                  Start Time
                                </label>

                                <input
                                  #fpInput
                                  type="text"
                                  data-fp-type="time"
                                  data-field="start"
                                  [attr.data-message-index]="i"
                                  [disabled]="loading || msg.uiState?.isFormSubmitted || isMessageDisabled(msg, isLast)"
                                />

                                <div class="time-preview">
                                  <div>
                                    <strong>Selected Time:</strong>
                                    {{ msg.uiState?.scheduleStartSelection || '-' }}
                                  </div>

                                  <div>
                                    <strong>UTC Time:</strong>
                                    {{ msg.uiState?.scheduleStartTime || '-' }}
                                  </div>
                                </div>

                              </div>

                              <div class="field time-field">

                                <label class="native-label">
                                  End Time
                                </label>

                                <input
                                  #fpInput
                                  type="text"
                                  data-fp-type="time"
                                  data-field="end"
                                  [attr.data-message-index]="i"
                                  [disabled]="loading || msg.uiState?.isFormSubmitted || isMessageDisabled(msg, isLast)"
                                />

                                <div class="time-preview">
                                  <div>
                                    <strong>Selected Time:</strong>
                                    {{ msg.uiState?.scheduleEndSelection || '-' }}
                                  </div>

                                  <div>
                                    <strong>UTC Time:</strong>
                                    {{ msg.uiState?.scheduleEndTime || '-' }}
                                  </div>
                                </div>

                              </div>

                            </div>

                            <div
                              class="form-error"
                              *ngIf="msg.uiState?.submitError"
                            >
                              {{ msg.uiState.submitError }}
                            </div>

                            <div class="card-actions">

                              <button
                                type="button"
                                class="send-btn predefined-submit-btn"
                                mat-flat-button
                                [disabled]="loading || msg.uiState?.isFormSubmitted || !msg.uiState?.isFormValid || isMessageDisabled(msg, isLast)"
                                (click)="submitSpecificDaySchedule(i)"
                              >
                                Submit
                              </button>

                            </div>

                          </div>

                        </div>
                    </ng-container>
                  </div>

                  <div *ngSwitchCase="'kv'" class="ui-kv">
                    <div class="assistant-text preserve-newlines" [innerHtml]="msg.messageHtml ? msg.messageHtml : msg.message"></div>
                    <div *ngFor="let item of msg.ui?.data">
                      <strong>{{ item.label }}:</strong> {{ item.value }}
                    </div>
                  </div>

                  <div *ngSwitchDefault class="preserve-newlines" [innerHtml]="msg.messageHtml ? msg.messageHtml : msg.message"></div>
                </ng-container>
                </ng-template>
              </ng-template>
            </div>
            <div class="timestamp">{{ msg.formatTime.split(' - ')[1] }}</div>
            
          </div>
            
        </div>
        <div class="message assistant" *ngIf="loading">
          <div class="avatar">
            <div class="assistant-avatar">
              <img src="../../../assets/feature-images/iris-logo.png" />
            </div>
          </div>
          <div class="bubble" style="padding-bottom: 12px;">
            <div *ngIf="isAwaiting" style="display: contents;" class="awaiting-text">Awaiting</div>
            <span class="typing-dot"></span>
            <span class="typing-dot"></span>
            <span class="typing-dot"></span>
          </div>
        </div>
      </div>

      <div class="chat-footer" >
        <div class="drag-footer-overlay"cdkDragHandle></div>
        <form class="group" [formGroup]="chatForm" (ngSubmit)="sendMessage($event)">
          <textarea class="custom-scroll" (keydown.enter)="onEnter($event)" formControlName="message" placeholder="Type a message..."></textarea>

            <button mat-icon-button class="send-btn" [disabled]="loading || chatForm.get('message')?.value?.trim() === '' || messages[messages.length - 1]?.disableUserInput" type="submit" >
              <mat-icon>send</mat-icon>
            </button>
          
            <button mat-icon-button class="send-btn" [disabled]="loading || !messages.length || disableMail" (click)="sendMail()" matTooltip="Contact CSM" >
              <mat-icon>attach_email</mat-icon>
            </button>
        </form>
        <div class="cs-info-container">
          <div class="cs-inline" [class.expanded]="isExpanded">
            <span class="cs-text">
              Iris may provide inaccurate results. She is intended to handle EARTHEYE support enquiries only. If in doubt about her response, please request a human agent to contact you. The platform's
              <a (click)="goToTerms()" class="terms-link">terms of use (TOU)</a>
              apply to your use of the Ask Iris feature.
            </span>

            <a class="view-toggle-link"
              (click)="toggleExpand()">
              {{ isExpanded ? 'View Less' : 'View More' }}
            </a>
          </div>
        </div>
      </div>

    </ng-container>

  </div>
</div>
